import React from 'react'
import ThemeButton from 'cms/CmsButton'

const Button = ({
  content: {
    text,
    link,
    target,
  },
  goto,
  style,
  settings: {
    selectStyle,
    ...otherSettings
  },
  currentLang,
  renderElement,
}) => (
  renderElement(
    ThemeButton,
    {
      style,
      ...otherSettings,
      primary: selectStyle === 'primary',
      secondary: selectStyle === 'secondary',
      children: text[currentLang],
      onClick: () => goto({ href: link, target }),
    },
  )
)

Button.propTypes = {}
Button.defaultProps = {}

export default Button



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/elements/button/Button.js